import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '📦 ¿Qué estoy comprando exactamente?',
  answer: 'Estás comprando el programa completo de Palomitas Gourmet: el ebook central con +30 recetas, la técnica de caramelización, 7 bonos exclusivos, el módulo premium de ventas en volumen y acceso de por vida con actualizaciones.'
}, {
  question: '⚡ ¿Tengo que saber cocinar profesionalmente?',
  answer: 'No, para nada. El programa está pensado para personas sin experiencia. Te enseñamos paso a paso con una olla común. Si sabés hervir agua, podés hacer palomitas gourmet.'
}, {
  question: '🚀 ¿Realmente puedo empezar sin plata?',
  answer: 'Con solo $3.500 en ingredientes básicos (maíz, azúcar, aceite y colorante) hacés tu primera tanda. Esa tanda puede generarte hasta $35.000 en ventas. La inversión es mínima.'
}, {
  question: '🔍 ¿Sirve si tengo poco tiempo por mis hijos?',
  answer: 'Sí, muchas de nuestras alumnas son mamás que producen mientras los chicos duermen o están en el colegio. Una tanda lleva menos de 1 hora y podés organizar tus tiempos.'
}, {
  question: '🧮 ¿Cómo calculo los precios con esta inflación?',
  answer: 'Incluimos una Calculadora de Rentabilidad en Excel que se actualiza. Ponés el precio de tus ingredientes y te dice exactamente cuánto cobrar para ganar bien, sin importar la inflación.'
}, {
  question: '🏪 ¿Necesito local o habilitación ya?',
  answer: 'No. Empezás desde tu cocina, vendiendo a conocidos, por WhatsApp y redes. Cuando escales, te guiamos con el módulo premium para vender en volumen.'
}, {
  question: '❌ ¿Y si no me funciona?',
  answer: 'Tenés 30 días de garantía blindada. Si no te gusta o no recuperás tu inversión, te devolvemos el 100% de tu dinero. Sin preguntas, sin vueltas.'
}];
export function Guarantee() {
  const [openItems, setOpenItems] = useState<number[]>([]);
  const toggleItem = (index: number) => {
    setOpenItems(prev => prev.includes(index) ? prev.filter(i => i !== index) : [...prev, index]);
  };
  return <section className="py-20 bg-[#f5f5f5]" data-id="element-105">
      <div className="container px-4 mx-auto max-w-3xl" data-id="element-106">
        {/* Garantía */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-20" data-id="element-107">
          <h2 className="text-3xl md:text-5xl font-bold font-serif text-[#2d3340] mb-3" data-id="element-108">
            Garantía Blindada de 30 Días
          </h2>
          <div className="w-16 h-1 bg-[#4a8c5c] mx-auto mb-8" data-id="element-109"></div>
          <p className="text-base md:text-lg text-[#5a5a5a] max-w-lg mx-auto mb-10 leading-relaxed" data-id="element-110">
            Estamos tan seguros de que este sistema funciona, que asumimos todo
            el riesgo. Si no recuperás tu inversión o no te gusta, te devolvemos
            el 100%.
          </p>

          <div className="bg-white rounded-full py-4 px-6 max-w-md mx-auto flex items-center gap-4 shadow-sm" data-id="element-111">
            <img src="https://cdn.magicpatterns.com/uploads/9zUf8Y16FF3mEjmDXQaik7/Captura_de_pantalla_2026-05-01_a_las_1.16.03_a._m..png" alt="Garantía 30 días" className="flex-shrink-0 w-14 h-14 object-contain" data-id="element-112" />
            <div className="text-left" data-id="element-113">
              <p className="font-bold text-[#2d3340] text-base" data-id="element-114">
                Garantía de Satisfacción Total
              </p>
              <p className="text-[#888] text-sm" data-id="element-115">
                Probá el sistema por 30 días sin riesgo
              </p>
            </div>
          </div>
        </motion.div>

        {/* Preguntas Frecuentes */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-116">
          <h2 className="text-3xl md:text-4xl font-bold font-serif text-[#2d3340] text-center mb-10" data-id="element-117">
            Preguntas Frecuentes (FAQ)
          </h2>
          <div className="w-16 h-1 bg-[#2ea043] mx-auto mb-10" data-id="element-118"></div>

          <div className="space-y-3" data-id="element-119">
            {faqs.map((faq, index) => {
            const isOpen = openItems.includes(index);
            return <motion.div key={index} initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: index * 0.05
            }} data-id="element-120">
                  <button onClick={() => toggleItem(index)} className="w-full text-left rounded-xl py-4 px-5 flex items-center justify-between gap-4 transition-all duration-300" style={{
                background: isOpen ? 'linear-gradient(135deg, rgba(46,160,67,0.15) 0%, rgba(52,211,153,0.08) 50%, rgba(46,160,67,0.12) 100%)' : 'linear-gradient(135deg, rgba(46,160,67,0.06) 0%, rgba(52,211,153,0.03) 50%, rgba(46,160,67,0.06) 100%)',
                border: isOpen ? '2px solid rgba(46,160,67,0.3)' : '2px solid transparent',
                boxShadow: isOpen ? '0 4px 25px rgba(46,160,67,0.15), inset 0 0 40px rgba(46,160,67,0.05)' : 'none'
              }} data-id="element-121">
                    <span className={`font-bold text-base md:text-lg ${isOpen ? 'text-[#2ea043]' : 'text-[#2d3340]'}`} data-id="element-122">
                      {faq.question}
                    </span>
                    <span className={`flex-shrink-0 text-xl font-light ${isOpen ? 'text-[#2ea043]' : 'text-[#2ea043]'}`} data-id="element-123">
                      {isOpen ? '−' : '+'}
                    </span>
                  </button>

                  <AnimatePresence data-id="element-124">
                    {isOpen && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.3,
                  ease: 'easeInOut'
                }} className="overflow-hidden" data-id="element-125">
                        <div className="px-5 pt-3 pb-5" data-id="element-126">
                          <p className="text-[#5a5a5a] leading-relaxed text-base" data-id="element-127">
                            {faq.answer}
                          </p>
                        </div>
                      </motion.div>}
                  </AnimatePresence>
                </motion.div>;
          })}
          </div>
        </motion.div>
      </div>
    </section>;
}